module.exports = __webpack_public_path__ + "img/icon_download_white.6d003ead.png";